<template>
    <div class="margem">
        <div v-if="anexos.length === 0" class="anexos-vazio">
        </div>
        <table v-else class="tabela tabela-anexos">
            <thead>
                <tr v-for="(a, index) in anexos" :key="a.id || index">
                    <td style="width: 2rem;">{{ index + 1 }}.</td>
                    <td style="text-align: left;">
                        <a class="anexo-link" :href="storageUrl + a.path" target="_blank">
                            {{ a.nome }}
                        </a>
                    </td>
                    <td>
                        <div v-if="!somenteLeitura" class="acoes-anexo">
                            <button type="button" class="btn-anexo btn-anexo--excluir" @click="$emit('excluir', a.id)"
                                :disabled="excluindoAnexoId === a.id">
                                {{ excluindoAnexoId === a.id ? 'Excluindo...' : 'Excluir' }}
                            </button>
                        </div>
                    </td>
                </tr>
            </thead>
        </table>
        <div v-if="!somenteLeitura" class="alinha-centro">
            <button type="button" class="btn-upload" @click="abrirSeletor" :disabled="anexando">
                <i class="bi-plus-circle"></i>
                {{ anexando ? 'Enviando...' : 'Adicionar anexo' }}
            </button>
        </div>
        <input ref="fileInput" style="display: none" type="file" multiple @change="onSelecionarArquivos">
    </div>
</template>

<script>
export default {
    name: "AnexosProjetoTab",
    props: {
        anexos: {
            type: Array,
            default: () => [],
        },
        storageUrl: {
            type: String,
            required: true,
        },
        anexando: {
            type: Boolean,
            default: false,
        },
        excluindoAnexoId: {
            type: [Number, String, null],
            default: null,
        },
        somenteLeitura: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["adicionar", "excluir"],
    methods: {
        abrirSeletor() {
            this.$refs.fileInput?.click()
        },
        onSelecionarArquivos(event) {
            const files = Array.from(event?.target?.files || [])
            if (files.length) this.$emit("adicionar", files)
            if (event?.target) event.target.value = ''
        },
    },
}
</script>

<style scoped>
.anexos-card {
    border: 1px solid var(--cor-separador);
    border-radius: 10px;
    padding: 1rem;
    background: var(--cor-bg);
}

.anexos-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
}

.anexos-header h3 {
    margin: 0;
}

.btn-upload {
    border: 1px solid var(--cor-primaria);
    color: var(--cor-primaria);
    background: transparent;
    border-radius: 999px;
    padding: .45rem .85rem;
    display: inline-flex;
    align-items: center;
    gap: .4rem;
    cursor: pointer;
}

.btn-upload:disabled {
    opacity: .7;
    cursor: not-allowed;
}

.tabela-anexos th,
.tabela-anexos td {
    vertical-align: middle;
}

.anexo-link {
    display: inline-flex;
    align-items: center;
    gap: .4rem;
    color: inherit;
    text-decoration: none;
}

.anexo-link:hover {
    text-decoration: underline;
}

.acoes-anexo {
    display: flex;
    gap: .45rem;
}

.btn-anexo {
    border: 1px solid var(--cor-separador);
    border-radius: 6px;
    padding: .25rem .55rem;
    font-size: 13px;
    background: var(--cor-bg);
    cursor: pointer;
}

.btn-anexo--ver {
    text-decoration: none;
    color: inherit;
}

.btn-anexo--excluir {
    color: var(--cor-erro);
    border-color: color-mix(in srgb, var(--cor-erro) 45%, var(--cor-separador));
}

.anexos-vazio {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    min-height: 120px;
    border: 1px dashed var(--cor-separador);
    border-radius: 8px;
    color: var(--cor-fonte-fraca);
}

@media (max-width: 760px) {
    .anexos-header {
        flex-direction: column;
        align-items: flex-start;
        gap: .6rem;
    }
}
</style>
